function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.74,
    y: 0.91,
    width: 10.5,
    height: 10.6,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.28,9.45,2.79,3.91A4,4,0,0,0,6,10.18,3.92,3.92,0,0,0,8.28,9.45Zm.93-.94a4,4,0,0,0,.72-2.3A4,4,0,0,0,6,2.23,3.87,3.87,0,0,0,3.71,3ZM.74,6.21A5.34,5.34,0,0,1,2.28,2.46a5.23,5.23,0,0,1,7.43,0,5.32,5.32,0,0,1,0,7.49,5.23,5.23,0,0,1-7.43,0A5.33,5.33,0,0,1,.74,6.21Z",
    style: {
      fill: "#ec2027"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelledIcon);
export default __webpack_public_path__ + "static/media/cancelled_icon.4ba336ebe6a642e80b3b19c020536b76.svg";
export { ForwardRef as ReactComponent };